
<div style="margin-top:40px">
    <tr >
        <td style="width: 19%">
          <label appendTo="body" class="text" for="stat" id="typeInput">Rapport type:</label>
        </td>
        <td>
          <div class="p-inputgroup" style="padding-left: 20px">
            <p-dropdown  id="reportDropdown" placeholder="Vælg rapport" [options]="data"
            optionLabel="report_name" optionValue="report_uuid" [(ngModel)] ="uuid"
              name="serviceType">
            </p-dropdown>
  
            <app-popover-btn id="typepopup"
              text="Vælg hvilken rapport, du ønsker at generer. Når du har valgt en rapport, får du vist en beskrivelse af rapporten."></app-popover-btn>
          </div>
          
        </td>
      </tr>

      <span style="padding-top: 20px;">
        <button pButton class="add-button" [disabled]="!uuid" (click)="generateReport()"  label="Generer rapport" type="submit" id="gemButton"></button>
      </span>
    
</div>